/**
 * @generated SignedSource<<e98fda8abf6921ab86c1ee26fcc800c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormsSubmitResponseMutationInput = {
  clientMutationId?: string | null;
  responseId: string;
};
export type RespondForm_submitResponse_Mutation$variables = {
  input: FormsSubmitResponseMutationInput;
};
export type RespondForm_submitResponse_Mutation$data = {
  readonly submitResponse: {
    readonly form: {
      readonly id: string;
      readonly responses: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"RespondForm_Response">;
          } | null;
        }>;
        readonly totalCount: number;
      };
    };
    readonly response: {
      readonly " $fragmentSpreads": FragmentRefs<"RespondForm_Response">;
    };
  } | null;
};
export type RespondForm_submitResponse_Mutation = {
  response: RespondForm_submitResponse_Mutation$data;
  variables: RespondForm_submitResponse_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "RespondForm_Response"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "respondedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Member",
    "kind": "LinkedField",
    "name": "responder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FormResponseAnswer",
    "kind": "LinkedField",
    "name": "answers",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "questionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "text",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__String",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "number",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__Numeric",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "checkboxes",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__Checkboxes",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "multipleChoice",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__MultipleChoice",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "date",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__Date",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "time",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__Time",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "dateTime",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__DateTime",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "phoneNumber",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__PhoneNumber",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "link",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__Link",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "email",
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "type": "CustomValue__Email",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RespondForm_submitResponse_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsSubmitResponseMutationPayload",
        "kind": "LinkedField",
        "name": "submitResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "form",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormResponseConnection",
                "kind": "LinkedField",
                "name": "responses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormResponseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormResponse",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RespondForm_submitResponse_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsSubmitResponseMutationPayload",
        "kind": "LinkedField",
        "name": "submitResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "form",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormResponseConnection",
                "kind": "LinkedField",
                "name": "responses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormResponseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormResponse",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c4bb217f6a42a4e02b079708e7ab4ce",
    "id": null,
    "metadata": {},
    "name": "RespondForm_submitResponse_Mutation",
    "operationKind": "mutation",
    "text": "mutation RespondForm_submitResponse_Mutation(\n  $input: FormsSubmitResponseMutationInput!\n) {\n  submitResponse(input: $input) {\n    form {\n      id\n      responses {\n        edges {\n          node {\n            ...RespondForm_Response\n            id\n          }\n        }\n        totalCount\n      }\n    }\n    response {\n      ...RespondForm_Response\n      id\n    }\n  }\n}\n\nfragment RespondForm_Response on FormResponse {\n  id\n  state\n  respondedAt\n  responder {\n    name\n    id\n  }\n  answers {\n    id\n    questionId\n    value {\n      __typename\n      ... on CustomValue__String {\n        text: value\n      }\n      ... on CustomValue__Numeric {\n        number: value\n      }\n      ... on CustomValue__Checkboxes {\n        checkboxes: value\n      }\n      ... on CustomValue__MultipleChoice {\n        multipleChoice: value\n      }\n      ... on CustomValue__Date {\n        date: value\n      }\n      ... on CustomValue__Time {\n        time: value\n      }\n      ... on CustomValue__DateTime {\n        dateTime: value\n      }\n      ... on CustomValue__PhoneNumber {\n        phoneNumber: value\n      }\n      ... on CustomValue__Link {\n        link: value\n      }\n      ... on CustomValue__Email {\n        email: value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a63ebcf8c84834f95e41a84ab68b5e1b";

export default node;
